// components/ClientInfoStep.tsx
import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { Row, Col, Typography, Divider } from 'antd';
import { SelectField } from '@/components/Form';
import { PreLodgementChecklistFormValues } from '../types/preLodgementChecklist';
import { getCurrentFY } from '../form/defaultValues';
import { TAX_RESIDENCY_OPTIONS, CITIZENSHIP_OPTIONS } from '@/constant/options';

const FY_OPTIONS = [0, 1, 2].map((offset) => {
  const endYear = getCurrentFY() - offset;
  const yy = String(endYear).slice(-2);
  return {
    label: `FY${yy} (1 Jul ${endYear - 1} – 30 Jun ${endYear})`,
    value: endYear,
  };
});

const { Title, Text } = Typography;

type Props = {
  control: Control<PreLodgementChecklistFormValues>;
  error: FieldErrors<PreLodgementChecklistFormValues>;
};

export const ClientInfoStep: React.FC<Props> = ({ control, error }) => {
  return (
    <div>
      <Title level={5} style={{ marginBottom: 4, marginTop: 0 }}>
        Personal Details
      </Title>
      <Text type="secondary">Tax year and residency basics.</Text>

      <Divider style={{ margin: '12px 0 20px' }} />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={24}>
          <SelectField
            formDirection="row"
            fullWidth={true}
            label="Tax financial year"
            name="taxFinancialYear"
            control={control}
            placeholder="Select tax financial year"
            options={FY_OPTIONS}
            required
            size="small"
            error={error?.taxFinancialYear?.message ?? ''}
          />
        </Col>
        <Col xs={24} md={24}>
          <SelectField
            formDirection="row"
            fullWidth={true}
            label="Citizenship"
            name="citizenship"
            control={control}
            placeholder="Select citizenship"
            options={CITIZENSHIP_OPTIONS}
            required
            size="small"
            error={error?.citizenship?.message ?? ''}
          />
        </Col>
        <Col xs={24} md={24}>
          <SelectField
            formDirection="row"
            fullWidth={true}
            label="Tax residency status"
            name="taxResidencyStatus"
            control={control}
            placeholder="Select tax residency status"
            options={TAX_RESIDENCY_OPTIONS}
            required
            size="small"
            error={error?.taxResidencyStatus?.message ?? ''}
          />
        </Col>
      </Row>
    </div>
  );
};
